<template>
	<div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" data-item="4">
		<div class="item">
			<div class="image-container">
				<router-link
					class="item-img-wrapper-link"
					:to="{
						name: 'ProductDetail',
						params: {id: product.id, slug: product.product_slug},
					}"
				>
					<img
						class="img-fluid"
						v-lazy="{
							src:
								API_URL +
								'/storage/uploads/' +
								(product.images.length > 0 ? product.images[0].name : 'no_image.png'),
							loading: publicPath + 'assets/images/spinner.gif',
							error: publicPath + 'assets/images/not_found.png',
						}"
					/>
				</router-link>
				<div class="item-action-behaviors" v-if="product.lowest_price_stock != 0">
					<a class="item-quick-look" data-toggle="modal" href="#quick-view"
						>Quick Look
					</a>
					<a class="item-mail" href="javascript:void(0)">Mail</a>
					<a
						class="item-addwishlist"
						href="javascript:void(0)"
						@click.prevent="
							addToWishlist({
								product_id: product.id,
								product_combination_id: product.lowest_price_relation.product_combination_id,
								warehouse_id: product.lowest_price_relation.warehouse_id,
							})
						"
						>Add to Wishlist</a
					>
					<a
						class="item-addCart"
						href="javascript:void(0)"
						@click.prevent="
							_addToCart({
								product_id: product.id,
								product_combination_id: product.lowest_price_relation.product_combination_id,
								price: product.lowest_price,
								warehouse_id: product.lowest_price_relation.warehouse_id,
							})
						"
						>Add to Cart</a
					>
				</div>
			</div>
			<div class="item-content">
				<div class="what-product-is">
					<ul class="bread-crumb">
						<li class="">
							<router-link
								:to="{
									name: 'ProductsByCategory',
									params: {id: product.category.id, slug: 'category-name'},
								}"
								>{{ product.category.name }}</router-link
							>
						</li>
					</ul>
					<h6 class="item-title">
						<router-link
							:to="{
								name: 'ProductDetail',
								params: {id: product.id, slug: product.product_slug},
							}"
							>{{ product.product_name }}</router-link
						>
					</h6>
					<div class="item-stars">
						<StarRating
							:rating="product.avg_rating"
							:star-size="20"
							:read-only="true"
							:show-rating="false"
						/>
					</div>
				</div>
				<div class="price-template">
					<div class="item-new-price">
						{{
							product.lowest_price_stock == "0"
								? "Out of stock"
								: formatCurrency(product.lowest_price)
						}}
					</div>
				</div>
			</div>
			<div class="tag new">
				<span>NEW</span>
			</div>
		</div>
	</div>
	<CartModal />
	<vue-element-loading
		:active="wishlistStatus.addToWishlist.loading"
		spinner="spinner"
		is-full-screen
		color="#343a40"
		text="Adding To Wishlist"
	/>
	<vue-element-loading
		:active="status.cart.loading"
		spinner="spinner"
		is-full-screen
		color="#343a40"
		text="Adding Product"
	/>
</template>

<script>
	import {mapGetters, mapActions} from "vuex";
	import CartModal from "../../Cart/CartModal.vue";
	import StarRating from "vue-star-rating";
	import {formatCurrency} from "../../../utils/common_functions";
	import {publicPath} from "../../../../vue.config";
	export default {
		props: ["product"],
		components: {CartModal, StarRating},
		computed: {
			...mapGetters("products", ["getStatus"]),
			...mapGetters("cart", ["getCarts", "status"]),
			...mapGetters("wishlist", ["getWishListItems"]),
			...mapGetters({wishlistStatus: "wishlist/status"}),
		},
		data() {
			return {
				API_URL: process.env.VUE_APP_API_URL,
				publicPath: publicPath,
			};
		},
		mounted() {},
		methods: {
			...mapActions("cart", ["addToCart"]),
			...mapActions("wishlist", ["addProductToWislist"]),
			formatCurrency,
			_addToCart(data) {
				this.addToCart(data);
			},
			addToWishlist(data) {
				// console.log(this.getWishListItems)
				this.addProductToWislist(data);
			},
		},
	};
</script>
<style scoped>
	.active {
		background: #ff3860;
		color: white;
	}
</style>
